import store from './store';
import { updateIntl } from 'react-intl-redux';
import { addLocaleData } from 'react-intl';
import en from 'react-intl/locale-data/en';
import fr from 'react-intl/locale-data/fr';

export default function initializeLocalization() {
    initializeLocalizationForStore(store);
}

export function initializeLocalizationForStore(store, loadTranslations = true) {
    addLocaleData([...en, ...fr]);
    setActiveLanguage('en');
}

export function getLanguages() {
    return [{ name: 'English', code: 'en' }, { name: 'French', code: 'fr' }];
}

export function setActiveLanguage(locale) {
    if (!locale || locale.trim() === '') {
        throw Error('Invalid language requested!');
    }

    let translations = require('./../assets/locales/messages.json');
    let messages = translations[locale];
    store.dispatch(
        updateIntl({
            locale,
            messages
        })
    );
}



// WEBPACK FOOTER //
// ./src/configuration/localization.js